import { Flex, styled, Card, Grid } from '@grupoboticario/flora-react';

const styles = {
  Card: styled(Card, {
    padding: '$4',
    minHeight: 'calc($5 * 10)',
  }),

  CardWrapper: styled(Flex, {
    height: '100%',
  }),

  Wrapper: styled(Flex, {
    background: '$backgroundPrimary',
    marginBottom: '$4',
    padding: '$6 0',
  }),

  Grid: styled(Grid, {
    gap: '$4',
    padding: '$6 0',

    '@tablet': {
      gridTemplateColumns: 'repeat(auto-fill, minmax(calc($20 * 4), 1fr))',
    },
  }),
};

export default styles;
